import { filterDateFieldClass, filterDateInputClass } from './uiClasses.js';

/**
 * Shared settlement filter card: status/view pills on the left, dates (and extras) on the right.
 */
export default function SettlementFilterBar({
  statusLabel = 'Status',
  tabs = [],
  activeTab,
  onTabChange,
  counts = {},
  fromDate = '',
  toDate = '',
  onFromDate,
  onToDate,
  extraLeft = null,
  extraRight = null,
  showDates = true,
  centerStatus = false,
  children = null,
}) {
  return (
    <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-3 sm:p-4 mb-4">
      <div className="flex flex-col lg:flex-row lg:items-end gap-4">
        {extraLeft}

        {tabs.length > 0 ? (
          <div className={centerStatus ? 'flex-1 min-w-0 lg:flex lg:flex-col lg:items-center' : 'flex-1 min-w-0'}>
            <label className="block text-xs font-medium text-gray-600 mb-1">{statusLabel}</label>
            <div className="flex flex-wrap gap-1.5 p-1 rounded-xl bg-gray-50 border border-gray-200">
              {tabs.map((tab) => {
                const active = activeTab === tab.id;
                const count = tab.count ?? counts[tab.id];
                return (
                  <button
                    key={tab.id}
                    type="button"
                    onClick={() => onTabChange?.(tab.id)}
                    className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs sm:text-sm font-semibold transition-colors ${
                      active
                        ? 'bg-white text-gray-900 shadow-sm border border-gray-200'
                        : tab.flash
                          ? 'animate-pulse ring-2 ring-emerald-400 bg-emerald-50 text-emerald-900'
                          : 'text-gray-600 hover:text-gray-900 hover:bg-white/70'
                    }`}
                  >
                    {tab.label}
                    {count != null ? (
                      <span
                        className={`min-w-[1.25rem] text-center rounded-full px-1.5 py-0.5 text-[10px] font-bold ${
                          active ? 'bg-blue-50 text-blue-700' : 'bg-gray-200/80 text-gray-600'
                        }`}
                      >
                        {count}
                      </span>
                    ) : null}
                  </button>
                );
              })}
            </div>
          </div>
        ) : (
          <div className="flex-1 min-w-0" />
        )}

        <div className="grid grid-cols-2 gap-2 sm:gap-3 w-full min-w-0 items-end lg:flex lg:flex-wrap lg:w-auto lg:shrink-0">
          {showDates ? (
            <>
              <div className={filterDateFieldClass}>
                <label className="block text-xs font-medium text-gray-600 mb-1">From date</label>
                <input
                  type="date"
                  value={fromDate}
                  onChange={(e) => onFromDate?.(e.target.value)}
                  className={filterDateInputClass}
                />
              </div>
              <div className={filterDateFieldClass}>
                <label className="block text-xs font-medium text-gray-600 mb-1">To date</label>
                <input
                  type="date"
                  value={toDate}
                  onChange={(e) => onToDate?.(e.target.value)}
                  className={filterDateInputClass}
                />
              </div>
            </>
          ) : null}
          {extraRight ? (
            <div className="col-span-2 lg:col-auto min-w-0 w-full lg:w-auto">
              {extraRight}
            </div>
          ) : null}
        </div>
      </div>
      {children}
    </div>
  );
}
